import styles from './ValidationError.module.scss';

import FormHelperText from '@material-ui/core/FormHelperText';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IValidationErrorProps {
  message?: string;
  children?: never;
}

const ValidationError: React.FunctionComponent<IValidationErrorProps & WithTranslation> = ({
  message,
  t,
}) => (
  <FormHelperText>
    <Typography variant="caption" color="error">
      <Icon fontSize="small" className={styles.warnIcon} color="error">
        warning
      </Icon>
      <span>{message ? message : t('required')}</span>
    </Typography>
  </FormHelperText>
);
const Translated = withTranslation()(ValidationError);

export { Translated as ValidationError };
